import { Route, Routes } from 'react-router-dom'
import ShopsPage from '../../pages/main/boutiques/page'
import ShopPage from '../../pages/main/boutiques/details'


export default function ShopNav() {
    return (
        <Routes>

            <Route path="/" element={<ShopsPage />} />
            <Route path="/secteur/:slug" element={<ShopsPage />} />

            <Route path="/:id" element={<ShopPage />} />


        </Routes>
    )
}
